import styled from 'styled-components';

import { EmptyListIcon, LensIcon } from '../../assets/members';
import { ThemeProp } from '../../theme/Themes';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 4rem 0;
`;

export const IconContainer = styled.div`
  position: relative;
  margin-bottom: 0.5rem;
`;

export const StyledLensIcon = styled(LensIcon).attrs((props: ThemeProp) => ({
  ...props,
  primary: props.theme.colors.mainColor,
  secondary: props.theme.colors.primary.c600,
}))`
  position: absolute;
  right: -1.5rem;
  bottom: -2rem;
`;

export const Title = styled.span`
  font-weight: ${(props: ThemeProp) => props.theme.fontWeight.medium};
  font-size: ${(props: ThemeProp) => props.theme.fontSize.l};
  line-height: ${(props: ThemeProp) => props.theme.lineHeight.l};
  text-align: center;
  color: ${(props: ThemeProp) => props.theme.colors.greyscale.c050};
  margin-bottom: 0.5rem;
  max-width: 80%;
  overflow-wrap: break-word;
`;

export const SubtitleContainer = styled.div`
  max-width: 16.25rem;
  text-align: center;
`;

export const Subtitle = styled.span`
  font-size: ${(props: ThemeProp) => props.theme.fontSize.s};
  line-height: ${(props: ThemeProp) => props.theme.lineHeight.mlg};
  font-weight: ${(props: ThemeProp) => props.theme.fontWeight.regular};
  color: ${(props: ThemeProp) => props.theme.colors.content.subdued.high};
`;

export const ClearLink = styled(Subtitle)`
  cursor: pointer;
  color: ${(props: ThemeProp) => props.theme.colors.main.c600};
`;

export const StyledEmptyListIcon = styled(EmptyListIcon).attrs((props: ThemeProp) => ({
  ...props,
  primary: props.theme.colors.mainColor,
  background: props.theme.colors.primary.c100,
}))``;
